import React, { ReactNode, useState } from "react"
import clsx from "clsx"
import styles from "./index.module.scss"
import { useLocalStorage } from "react-use"

export type ViewerWrapperProps = {
  children: ReactNode
}

const ViewerWrapper: React.FC<ViewerWrapperProps> = ({ children }) => {
  const [showBackgroundSettings, setShowBackgroundSettings] = useState(false)
  const [background, setBackground] = useLocalStorage<number>(
    "viewer_page_backgroundType",
    0,
  )

  return (
    <>
      <div
        className={clsx({
          [styles.viewerBackground]: true,
          [styles.viewerBackgroundDline]: background === 0,
          [styles.viewerBackgroundWall]: background === 1,
          [styles.viewerBackgroundCream]: background === 2,
          [styles.viewerBackgroundWhite]: background === 3,
          [styles.viewerBackgroundBlack]: background === 4,
        })}
      >
        {children}
        <div
          className={styles.settingsWrapper}
          onMouseLeave={() => setShowBackgroundSettings(false)}
        >
          <div
            className={clsx({
              [styles.settings]: true,
              [styles.isShow]: showBackgroundSettings,
            })}
          >
            <button
              onClick={() => setBackground(0)}
              className={styles.buttonDline}
            >
              <span>斜線</span>
            </button>
            <button
              onClick={() => setBackground(1)}
              className={styles.buttonWall}
            >
              <span>白壁</span>
            </button>
            <button
              onClick={() => setBackground(2)}
              className={styles.buttonCream}
            >
              <span>クリーム</span>
            </button>
            <button
              onClick={() => setBackground(3)}
              className={styles.buttonWhite}
            >
              <span>白</span>
            </button>
            <button
              onClick={() => setBackground(4)}
              className={styles.buttonBlack}
            >
              <span>黒</span>
            </button>
          </div>
          <div className={styles.changeButtonWrapper}>
            <div
              className={styles.changeButtonHiddenArea}
              onMouseLeave={() => setShowBackgroundSettings(false)}
            ></div>
            <div
              className={styles.changeButton}
              onMouseEnter={() => setShowBackgroundSettings(true)}
            >
              <i className="fas fa-cog"></i>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewerWrapper
